import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  getNotifications as getNotificationsApi,
  addNewNotification as addNewNotificationApi,
  updateNotification as updateNotificationApi,
  deleteNotification as deleteNotificationApi,
} from "../../helpers/realbackend_helper";

export const getNotifications = createAsyncThunk(
  "crm/getNotifications",
  async ({ ntf_tunnel }, { rejectWithValue }) => {
    try {
      const response = await getNotificationsApi({ ntf_tunnel });
      return response;
    } catch (err) {
      return rejectWithValue(err.message || "Failed to fetch notify");
    }
  }
);

export const addNewNotification = createAsyncThunk(
  "notification/addNewNotification",
  async (notification) => {
    try {
      const response = addNewNotificationApi(notification);
      toast.success("Мэдээллийг амжилттай нэмлээ", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Шинэ мэдээллийг нэмэхэд алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const updateNotification = createAsyncThunk(
  "notification/updateNotification",
  async ({ ids }, { rejectWithValue }) => {
    try {
      const response = await updateNotificationApi({ ids });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteNotification = createAsyncThunk(
  "notification/deleteNotification",
  async (notification) => {
    try {
      const response = deleteNotificationApi(notification);
      toast.success("Мэдээллийг амжилттай устгалаа", {
        autoClose: 3000,
      });
      return { notification, ...response };
    } catch (error) {
      toast.error("Мэдээллийг устгахад алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);
